/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { RECEIVE_RATINGS_CONFIG, FETCHING_RATINGS_CONFIG, SAVE_RATINGS_COLOR_CONFIG, SAVING_RATINGS_COLOR_CONFIG, SAVE_RATING_GENERAL_SUCCESS, SAVING_RATING_GENERAL } from 'state/actions/ratingsState/configStatus';
import { transpileRatingsData, transpileColorConfiguration, transpileGeneral } from 'state/reducers/ratingsState/transpilers';


/* ========== ~~~~~~~~~~  CONFIG : REDUCER ~~~~~~~~~~ ========== */
//transpiler


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = transpileRatingsData({});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
const configStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_RATINGS_CONFIG:
            newState = transpileRatingsData(action.data);
            return newState;
        case FETCHING_RATINGS_CONFIG:
            newState.fetchingRatingsConfig = action.status;
            return newState;
        case SAVE_RATINGS_COLOR_CONFIG:
            newState.configuration.colorConfiguration = transpileColorConfiguration(action.data);
            return newState;
        case SAVING_RATINGS_COLOR_CONFIG:
            newState.savingColorConfiguration = action.status;
            return newState;
        case SAVING_RATING_GENERAL:
            newState.configuration.savingGeneral = action.status;
            return newState;
        case SAVE_RATING_GENERAL_SUCCESS:
            newState.configuration = {...newState.configuration, ...transpileGeneral(action.data)}
            return newState
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default configStatus;
